import { Box, Divider, Typography } from '@mui/material';
import { AmountWithCurrency } from 'src/shared/components/atoms/amountWithCurrency';

type StatisticsTitleAndValueRowProps = {
  title: string;
  value: string;
  currencyValue?: number;
  uppercase?: boolean;
  divider?: boolean;
  bigValue?: boolean;
  endEndornment?: string;
  py?: number;
};

export const StatisticsTitleAndValueRow = (props: StatisticsTitleAndValueRowProps) => {
  const { title, value, uppercase = false, divider = false, endEndornment = undefined, bigValue = false, py = 0.5, currencyValue } = props;
  return (
    <>
      <Box sx={{ py, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Typography
          color='textSecondary'
          variant='body2'
          fontWeight={(thm) => thm.typography.fontWeightMedium}
          textTransform={uppercase ? 'uppercase' : 'none'}
        >
          {title}
        </Typography>
        <Box>
          {currencyValue !== undefined && currencyValue !== null ? (
            <Typography variant='h5' fontWeight={(thm) => thm.typography.fontWeightBold} display='inline'>
              <AmountWithCurrency amount={currencyValue} decimals={0} showCurrencyInSecondaryStyle currencyVariant='body2' />
            </Typography>
          ) : (
            <>
              <Typography
                variant={bigValue ? 'h5' : 'body1'}
                fontWeight={(thm) => (bigValue ? thm.typography.fontWeightBold : thm.typography.fontWeightMedium)}
                display='inline'
              >
                {value}
              </Typography>
              {endEndornment && (
                <Typography display='inline' color='textSecondary'>
                  {` ${endEndornment}`}
                </Typography>
              )}
            </>
          )}
        </Box>
      </Box>
      {divider && <Divider />}
    </>
  );
};
